export default __webpack_public_path__ + "static/media/asure-logo-black.1b5e2c84.png";